import React from 'react';
import { createContext } from 'react';
import{createUserWithEmailAndPassword, getAuth, onAuthStateChanged, signInWithEmailAndPassword, signInWithPopup, signOut} from 'firebase/auth'
import app from '../../firebase/firebase.init';
import { useState } from 'react';
import { useEffect } from 'react';

export const AuthContext=createContext()
const auth=getAuth(app);


const AuthProvider = ({children}) => {

    const [user ,setUser]=useState(null)

   const providerLogin=(provider)=>{
    return signInWithPopup(auth,provider)
    }
    const createUser=(email,password)=>{
        return createUserWithEmailAndPassword(auth,email,password)
    }

     const logIn=(email,password)=>{
        return signInWithEmailAndPassword(auth,email,password);
     }    
         
    const logOut=()=>{
        return signOut(auth);
    }

    useEffect(()=>{
       const unSubscribe= onAuthStateChanged(auth,(newUser)=>{
        //    console.log('current user',newUser)
            setUser(newUser);
        })
       return () =>{
        unSubscribe();
       }

    },[])

 const authInfo={user,providerLogin,logOut,createUser,logIn};
    return (
       <AuthContext.Provider value={authInfo}>
           {children}
       </AuthContext.Provider>
    );
};

export default AuthProvider;